




























import Vue, { PropType } from "vue";
import VcCloudContractsChangePlanNames from "@/components/AboutCloudContractsChangePlans/CloudContractsChangePlanNames.vue";
import VcCloudContractsChangePlansCaptions from "@/components/AboutCloudContractsChangePlans/CloudContractsChangePlansCaptions.vue";

export interface AboutCloudContractsChangePlansProps {
  lang: any;
  oldPlanTranslatedName: string;
  newPlanTranslatedName: string;
  newPlanApplyAt: number;
  isUpgrade: boolean;
  aboutHandlingUrl: string;
  aboutCalculationUrl: string;
  priceDifference: number;
  aboutFreeTrialCalculationUrl: string;
}

export default Vue.extend({
  name: "vc-about-cloud-contracts-change-plans",
  components: {
    VcCloudContractsChangePlansCaptions,
    VcCloudContractsChangePlanNames
  },

  props: {
    lang: {
      type: Object as PropType<AboutCloudContractsChangePlansProps["lang"]>,
      default: () => {}
    },
    oldPlanTranslatedName: {
      type: String as PropType<
        AboutCloudContractsChangePlansProps["oldPlanTranslatedName"]
      >,
      default: ""
    },
    newPlanTranslatedName: {
      type: String as PropType<
        AboutCloudContractsChangePlansProps["newPlanTranslatedName"]
      >,
      default: ""
    },
    newPlanApplyAt: {
      type: Number as PropType<
        AboutCloudContractsChangePlansProps["newPlanApplyAt"]
      >,
      default: 0
    },
    isUpgrade: {
      type: Boolean as PropType<
        AboutCloudContractsChangePlansProps["isUpgrade"]
      >,
      default: false
    },
    aboutHandlingUrl: {
      type: String as PropType<
        AboutCloudContractsChangePlansProps["aboutHandlingUrl"]
      >,
      default: ""
    },
    aboutCalculationUrl: {
      type: String as PropType<
        AboutCloudContractsChangePlansProps["aboutCalculationUrl"]
      >,
      default: ""
    },
    priceDifference: {
      type: Number as PropType<
        AboutCloudContractsChangePlansProps["priceDifference"]
      >,
      default: 0
    },
    aboutFreeTrialCalculationUrl: {
      type: String as PropType<
        AboutCloudContractsChangePlansProps["aboutFreeTrialCalculationUrl"]
      >,
      default: ""
    }
  }
});
